import { OAuthExternalCallbackPage } from "src/features/integrations/sources/oauth/OAuthExternalCallbackPage.js";

export const VismaEconomicExternalCallbackPage = () => {
	return <OAuthExternalCallbackPage />;
};
